const getStyles = (column) => {
    return Object.assign(Object.assign(Object.assign({}, (column.minWidth && { minWidth: column.minWidth })), (column.width && { width: column.width })), (column.maxWidth && { maxWidth: column.maxWidth }));
};
const useColumnSize = (hooks) => {
    hooks.getHeaderProps.push((props, params) => [
        props,
        {
            style: getStyles(params.column),
        },
    ]);
    hooks.getCellProps.push((props, params) => [
        props,
        {
            style: getStyles(params.cell.column),
        },
    ]);
};

export { useColumnSize as default };
//# sourceMappingURL=useColumnSize.js.map
